export enum ScopeType {
    national = 1,
    capital = 2,
}
